module.exports = __webpack_public_path__ + "img/sprinter.75aa39a6.svg";